import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsPositionViewer = {
    autoComplete: 'organization-title',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map